import { render, staticRenderFns } from "./ElevatorGroup.vue?vue&type=template&id=67c587f5"
import script from "./ElevatorGroup.vue?vue&type=script&lang=ts"
export * from "./ElevatorGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports